<template>
  <collapse class="show-hide" title="Montrer / Cacher" :defaultCollapse="true" :data-show="filters.length > 1">
    <el-tag
      class="filter"
      v-for="item in filters"
      :key="item.id"
      :type="item.type"
      :effect="item.effect"
      size="mini"
      @click="filterHide(item)"
      :title="item.name"
    >{{ item.name}}</el-tag>
  </collapse>
</template>

<script>
import Collapse from '@/components/tools/collapse/Collapse'

export default {
  name: 'SportGamesFiltersShowHide',
  components: { Collapse },
  props: {
    games: Array
  },
  data () {
    return {
      filtersStatus: []
    }
  },
  computed: {
    seasonsFull () { return this.$store.getters['Sport/Season/list'] },
    competitionsFull () { return this.$store.getters['Sport/Competition/list'] },
    roundsTypeFull () { return this.$store.getters['Sport/RoundType/list'] },
    groupsTypeFull () { return this.$store.getters['Sport/GroupType/list'] },
    gendersFull () { return this.$store.getters['Sport/Gender/list'] },
    disciplinesFull () { return this.$store.getters['Sport/Discipline/list'] },
    sportsFull () { return this.$store.getters['Sport/Sport/list'] },
    eventsFull () { return this.$store.getters['Sport/Event/list'] },
    eventUnitsFull () { return this.$store.getters['Sport/EventUnit/list'] },

    seasonsId () { return [...new Set(this.games.map(item => item.seasonId))] },
    competitionsId () { return [...new Set(this.games.map(item => item.competitionId))] },
    roundsTypeId () { return [...new Set(this.games.map(item => item.roundTypeId))] },
    groupsTypeId () { return [...new Set(this.games.map(item => item.groupTypeId))] },
    gendersId () { return [...new Set(this.games.map(item => item.genderId))] },
    disciplinesId () { return [...new Set(this.games.map(item => item.disciplineId))] },
    sportsId () { return [...new Set(this.games.map(item => item.sportId))] },
    eventsId () { return [...new Set(this.games.map(item => item.eventId))] },
    eventUnitsId () { return [...new Set(this.games.map(item => item.eventUnitId))] },

    seasonsFilter () { return this.seasonsFull.filter(item => this.seasonsId.indexOf(item.id) > -1) },
    competitionsFilter () { return this.competitionsFull.filter(item => this.competitionsId.indexOf(item.id) > -1) },
    roundsTypeFilter () { return this.roundsTypeFull.filter(item => this.roundsTypeId.indexOf(item.id) > -1) },
    groupsTypeFilter () { return this.groupsTypeFull.filter(item => this.groupsTypeId.indexOf(item.id) > -1) },
    gendersFilter () { return this.gendersFull.filter(item => this.gendersId.indexOf(item.id) > -1) },
    disciplinesFilter () { return this.disciplinesFull.filter(item => this.disciplinesId.indexOf(item.id) > -1) },
    sportsFilter () { return this.sportsFull.filter(item => this.sportsId.indexOf(item.id) > -1) },
    eventsFilter () { return this.eventsFull.filter(item => this.eventsId.indexOf(item.id) > -1) },
    eventUnitsFilter () { return this.eventUnitsFull.filter(item => this.eventUnitsId.indexOf(item.id) > -1) },

    filters () {
      const value = this.initFilter(this.seasonsFilter, 's', 'name', 'success')
        .concat(
          this.initFilter(this.competitionsFilter, 'c', 'nameFr', 'info'),
          this.initFilter(this.sportsFilter, 'sp', 'name', 'warning'),
          this.initFilter(this.disciplinesFilter, 'd', 'nameFr', 'danger'),
          this.initFilter(this.eventsFilter, 'e', 'nameFr', 'info'),
          this.initFilter(this.gendersFilter, 'g', 'nameFr', 'success'),
          this.initFilter(this.eventUnitsFilter, 'eu', 'nameFr', 'info'),
          this.initFilter(this.roundsTypeFilter, 'rt', 'name', 'warning'),
          this.initFilter(this.groupsTypeFilter, 'gt', 'name', 'danger')
        )
      return value
    }
  },
  methods: {
    filterHide (item) {
      const index = this.filtersStatus.indexOf(item.id)
      if (index > -1) {
        this.filtersStatus.splice(index, 1)
      } else {
        this.filtersStatus.push(item.id)
      }
      this.$emit('change', this.filtersStatus)
    },
    initFilter (list, prefixKey, name, type) {
      const values = []
      if (list.length > 1) {
        for (const i in list) {
          const item = list[i]
          const key = prefixKey + item.id
          values.push({ id: key, name: item[name], type: type, effect: this.effect(key) })
        }
      }
      return values
    },
    effect (key) { return this.filtersStatus.indexOf(key) > -1 ? 'light' : 'dark' }
  }
}
</script>

<style scoped>
  .content > span{
    margin:2px
  }
  .show-hide{
    transition: opacity 0.3s ease;
  }
  .show-hide:not([data-show="true"]){
    opacity: 0;
  }
</style>
